<template>
  <b-modal size="lg" id="appointmentModal" title="Appointment Details">
    <div class="row">
        <div class="col-sm-6">
            <div class="d-flex flex-column">
                <label class="font-weight-bold">
                Name
            </label>
            <span>
                {{item.member}}
            </span>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="d-flex flex-column">
                <label class="font-weight-bold">
                Staff Name
            </label>
            <span>
                {{item.staff}}
            </span>
            </div>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-sm-6">
            <div class="d-flex flex-column">
                <label class="font-weight-bold">
                Appointment Date
            </label>
            <span>
                {{formatDate(item.arrivalDate,'DD MMM YYYY hh:mm:ss a')}}
            </span>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="d-flex flex-column">
                <label class="font-weight-bold">
                Source
            </label>
            <span>
                {{item.source}}
            </span>
            </div>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-sm-6">
            <div class="d-flex flex-column">
                <label class="font-weight-bold">
                Appointment Duration
            </label>
            <span>
                {{item.duration}} Minutes
            </span>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="d-flex flex-column">
                <label class="font-weight-bold">
                Color
            </label>
            <span>
                {{item.color}}
            </span>
            </div>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-sm-6">
            <div class="d-flex flex-column">
                <label class="font-weight-bold">
                Status
            </label>
            <div>
                <span
                  class="badge badge-success fw-400"
                  v-if="item.completedDate != 0"
                  >Completed</span
                >
                <span
                  class="badge badge-warning fw-400"
                  v-else-if="item.noshowDate !== 0"
                  >No Show</span
                >
                <span class="badge badge-primary fw-400" v-else>Approved</span>
            </div>
            </div>
        </div>
    </div>
        <div class="row mt-4">
        <div class="col-sm-6">
            <div class="d-flex flex-column">
                <label class="font-weight-bold">
                Remarks
            </label>
            <div>
                {{item.remarks !== undefined ? item.remarks:'-'}}
            </div>
            </div>
        </div>
    </div>
    <template slot="modal-footer">
        <b-row style="border=top:1px solid black;width:100%;">
          <div class="d-flex justify-content-between w-100">
                      <b-button
            class="mr-2"
                    pill
                    variant="danger"
                    @click="emitDetail(item.bookID, 'delete')"
                    >Delete <i class="fa fa-times-cross fs-xl"></i
                  ></b-button>
                  <div>
                                <b-button
            class="mr-2"
                    pill
                    variant="warning"
                    @click="emitDetail(item.bookID, 'noshow')"
                    >No Show <i class="fa fa-times-circle fs-xl"></i
                  ></b-button>
                  <b-button
                    class="mr-2"
                    pill
                    variant="success"
                    @click="emitDetail(item.bookID, 'completed')"
                    >Completed <i class="fa fa-check-circle fs-xl"></i
                  ></b-button>
                  <b-button
                    class="mr-2"
                    pill
                    variant="danger"
                    @click="emitDetail(item.bookID, 'blocked')"
                    >Block <i class="fa fa-exclamation-triangle fs-xl"></i
                  ></b-button>
                  </div>
          </div>

        </b-row>
    </template>
  </b-modal>
</template>
<script>
import { handleSessionExpired } from "./../../../../assets/js/dashboard/dashboard.js";
import moment from "moment";
export default {
  name: "appointmentModal",
  props: {
    item: Object,
  },
  data() {
    const user = this.$props.item;
    return {
        user
    };
  },
  methods: {
    async emitDetail(bookID, operation) {
      let $vm = this;
      var result = {};
      let url = this.$api.BOOKING + "/" + bookID + "/" + operation;
      await $vm
        .$axios({
          method: "post",
          url: url,
          baseURL: "https://appt.tunai.io/",
          headers: { token: $vm.$session.get("token") },
        })
        .then((response) => {
          this.toastrExe(
            "Appointment Update",
            operation=='delete'?`Book ID:${bookID} has been deleted`:`Update for Book ID:${bookID} Successful`,
            "success"
          );
          result = response.data;
        })
        .catch((err) => {
          this.toastrExe(
            "Appointment Update",
            `Update for Book ID:${bookID} Failed`,
            "danger"
          );
          var errData = err.response?.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
        this.$emit('detailEdited');
        this.$bvModal.hide("appointmentModal")
    },
    toastrExe(title, body, variant) {
      this.$bvToast.toast(body, {
        title: title,
        variant: variant,
        solid: true,
      });
    },
    formatDate(date,format) {
      return moment(date).format(format);
    },
  },
};
</script>
<style scoped>
.modal-footer{
    display: flex;
flex-wrap: wrap;
align-items: center;
justify-content: flex-end;
padding: 1rem;
border-top: 1px solid #828282;
border-bottom-right-radius: 3px;
border-bottom-left-radius: 3px;
}
</style>